import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type {
	CreateShopReturnReasonDto,
	ShopDto,
} from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useAddReturnReason(shop: ShopDto) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShop = useInvalidateShop(shop.id);
	const mutation = $api.useMutation("post", "/shops/{shopId}/reasons");

	return useMutation({
		onSuccess: () => {
			invalidateShop();
			successNotification();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async (variables: CreateShopReturnReasonDto) => {
			return mutation.mutateAsync({
				params: { path: { shopId: shop.id } },
				body: variables,
			});
		},
	});
}
